export default "__VITE_ASSET__1520aa3c__"